<template>
  <div class="content Tabs">

     <b-tabs card>

          <b-tab :title="lang.tab_ImportIPC"  :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="file-import">

              <b-form class="file-form">
                <p>{{lang.label_file}}:</p>
                <br>
                <b-row>
                  <b-col >
                    <b-form-file
                      v-model="file"
                      :state="Boolean(file)"
                      :placeholder= lang.placeholder_file
                      drop-placeholder= lang.placeholder_file
                      class="import-file"
                      accept=".xml"
                      size="sm"
                      

                    ></b-form-file>
                  </b-col>
                  <b-col>
                    <!-- <b-button @click="uploadFile" class="upload-form-button" size="sm" :variant="variant">{{lang.button_Upload}}</b-button> -->

                  </b-col>
                </b-row>
                
                  
              </b-form>
              
            </b-container>
            <br><br>
            <b-container v-if="isLoaded" class="ipc-viewer">
              <IpcViewerComponent name="CompareVariants" :lang="lang.IPCViewer" :zooming="true"></IpcViewerComponent>
            </b-container>
          </b-tab>


        </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import IpcViewerComponent from '@/components/shared/IpcViewerComponent'


export default {
  name: "Content",
  components: {
    IpcViewerComponent
    

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      file: null,
      isLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      

    }),
    
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }
  },
  created () {
    
  },

  updated() {
    
  },
  watch: {
    file: function (newVal, oldVal) {

      this.uploadFile();
    },
  },
  methods: {
    resetSVG() {
      this.isLoaded = false;
    },
    uploadFile() {

      this.resetSVG();
      

      let vue = this;

      let obj = {
        file:{
          file: this.file,
        },
        
        projectRevisionId: this.$route.query.revisionId

      }

      this.$store.dispatch("showLoader", { visible: true, text: "load" });
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_importIpc", obj)
      .then(function(result) {
        
        console.log(result)
        vue.$store.dispatch("showLoader", {visible: false});
        if (result.data == 1){

          const obj = {
            text: vue.lang.alert_success_importIPC,
            time: 10,
            type: "success"
          }

          
          vue.$store.dispatch("displayFooterAlert", obj);

          //reload ipc viewer
          vue.isLoaded = true;
          
        }else{
          const obj = {
            text: vue.lang.alert_error_importIPC,
            time: 15,
            type: "danger"
          }

          
          vue.$store.dispatch("displayFooterAlert", obj);
          vue.isLoaded = false;

        }



      })

    },


  },
  
}
</script>

<style lang="scss">
.Tabs{
    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

    .file-form{
      width: 50%;
    }

    .upload-form-button{

      margin-left: 10px;
      margin-top: 2px;
    }
    .textarea-descr{
      margin-top: 2px;
    }
    .file-import{
      margin-left: 10px;
    }
    .ipc-viewer{
      max-width: 40%;
      height: 400px;
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectImportIPC/Middle/Content/Content.vue